import { Alert, Button, DateInput } from '@octano/global-ui';
import { useForm, FormProvider } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Form, Row } from 'reactstrap';
import { IdentificationType } from '../../api/requests/tuitionProcess';

import { ReactComponent as AddemicProductLogo } from '../../assets/addemic/logo_expanded.svg';
import { IS_ADDEMIC } from '../../config/constants';
import { LoginInputs } from './types';
import IdentificationForm from '../IdentificationForm';

interface LoginFormProps {
  identificationTypes?: IdentificationType[];
  errorLogin: string;
  toggleError: () => void;
  onLogin: (values: LoginInputs) => void;
}

const LoginForm = ({
  errorLogin,
  identificationTypes = [],
  toggleError,
  onLogin,
}: LoginFormProps) => {
  const prefix = 'loginTuitionProcess';
  const { t } = useTranslation();
  const { state: defaultValues } = useLocation<Partial<LoginInputs>>();

  const form = useForm<LoginInputs>({ mode: 'onChange', defaultValues });
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = form;

  return (
    <Row className="py-5">
      <Col xs={12} className="text-center">
        {IS_ADDEMIC ? (
          <AddemicProductLogo style={{ maxHeight: 80 }} />
        ) : (
          <img
            src="/tenant/logo_expanded.svg"
            alt="tenant_logo"
            style={{ maxHeight: 100 }}
          />
        )}
      </Col>
      <Col xs={12}>
        <p className="text-center py-4">
          <Trans t={t}>{t(`${prefix}.welcome`)}</Trans>
        </p>
      </Col>

      <Col xs={12}>
        <Alert
          color="danger"
          icon="error"
          noFill
          size="sm"
          text={errorLogin !== '' ? t(`${prefix}.${errorLogin}`) : ''}
          isOpen={errorLogin !== ''}
          toggle={toggleError}
        />
      </Col>

      <Col xs={12}>
        <FormProvider {...form}>
          <Form onSubmit={handleSubmit(onLogin)}>
            <Row>
              <IdentificationForm identificationTypes={identificationTypes} />
              <Col xs="12">
                <DateInput
                  name="birthday"
                  label={t(`${prefix}.labelBirthday`)}
                  rules={{ required: true }}
                  control={control}
                />
              </Col>
              <Col xs="12">
                <Button
                  type="submit"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  text={t(`${prefix}.loginBtn`)}
                  fullwidth
                />
              </Col>
            </Row>
          </Form>
        </FormProvider>
      </Col>
      {/*
      <Col xs={12} className="pb-1 text-center">
        <div className="mb-0 text-center text-underline color-primary">
          {t(`${prefix}.howToLogin`)}
        </div>
      </Col>
      */}
    </Row>
  );
};

export default LoginForm;
